import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const EmailIcon = ({ color = '#000', height = '12px', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 12"
    height={height}
    {...props}
  >
    <path
      d="M1.39 0c-.182 0-.355.038-.514.101l8.066 6.837c.353.299.747.299 1.1 0L18.118.093A1.406 1.406 0 0017.61 0H1.39zM.014 1.183C.005 1.248 0 1.317 0 1.385v9.23C0 11.383.62 12 1.39 12h16.22c.77 0 1.39-.617 1.39-1.385v-9.23c0-.068-.005-.137-.014-.202L10.948 7.99a2.264 2.264 0 01-2.91 0L.013 1.183z"
      fill={color}
    />
  </svg>
);

EmailIcon.propTypes = propTypes;

export default EmailIcon;
